<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid fill-height>
        <v-layout >
          <v-flex xs12>
            <p class="display-1 text-no-wrap text-md-center font-weight-thin font-italic"></p>
            <v-card class="mx-auto" max-width="500">
              <v-img
                src="https://storage.googleapis.com/spitzer-risc-logos/new-clinic-little.png"
                lazy-src="https://picsum.photos/id/11/10/6"
                class="grey lighten-2"
              ></v-img>
              <div class="backgroud-logo logo">
              </div>
              <v-card-title primary-title>
                <v-card-text>
                    <v-form
                      ref="form"
                      v-model="valid"
                    >

                      <v-select
                        v-model="auth.customerId"
                        ref="customerId"
                        :items="items"
                        item-text="name"
                        item-value="id"
                        :rules="[v => !!v || 'Clinica/Hospital é Obrigatório!']"
                        label="Clinica/Hospital"
                        required
                        return-object
                      ></v-select>

                      <v-text-field
                        v-model="auth.username"
                        :rules="emailRules"
                        label="E-mail"
                        required
                      ></v-text-field>

                      <v-text-field
                        v-model="auth.crm"
                        :counter="8"
                        :rules="crmRules"
                        label="CRM"
                        required
                      ></v-text-field>

                      <v-text-field
                        v-model="auth.name"
                        :counter="40"
                        :rules="nameRules"
                        label="Nome"
                        required
                      ></v-text-field>

                      <v-text-field
                        v-model="auth.password"
                        :append-icon="showPass ? 'visibility' : 'visibility_off'"
                        :rules="[rules.required, rules.min]"
                        :type="showPass ? 'text' : 'password'"
                        name="password"
                        label="Senha"
                        hint="O ideal é ter mais de 8 caracteres!"
                        counter
                        @click:append="showPass = !showPass"
                        loading
                      >
                        <template v-slot:progress>
                          <v-progress-linear
                            :value="progress"
                            :color="color"
                            height="7"
                          ></v-progress-linear>
                        </template>
                      </v-text-field>

                      <v-text-field
                        class="password"
                        type="password"
                        label="Confirme sua senha"
                        v-model="auth.confpass"
                        :rules="[v => !!v || 'Você deve informar a senha!']" required
                      ></v-text-field>

                      <v-checkbox
                        v-model="checkbox"
                        :rules="[v => !!v || 'para continuar deve se concordar!']"
                        label="Você concorda?"
                        required
                      ></v-checkbox>

                      <v-btn
                        color = 'primary'
                        block
                        :disabled="!valid"
                        @click="submit()"
                      >
                        Registrar
                      </v-btn>
                      <br><hr><br>
                      <router-link to="/auth/login">
                        <v-btn block >Retornar para Login</v-btn>
                      </router-link>

                    </v-form>
                </v-card-text>
              </v-card-title>
              <v-card-actions>
                <div>
                  <p>© 2017 - {{ new Date().getFullYear() }} <a href="http://www.spitzer.io">Spitzer.io</a> - Todos os direitos reservados</p>
                </div>

              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
        <v-snackbar
          :timeout="snackbarConfig.timeout"
          :color="snackbarConfig.color"
          :multi-line="snackbarConfig.mode === 'multi-line'"
          :vertical="snackbarConfig.mode === 'vertical'"
          v-model="snackbarConfig.snackbar"
        >
          {{ snackbarConfig.text }}
          <v-btn dark flat @click.native="snackbarConfig.snackbar = false">Fechar</v-btn>
        </v-snackbar>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  export default {
    mounted () {
      this.snackbarConfig.snackbar = true
      this.snackbarConfig.text = 'Como seu E-Mail não foi encontrado, faça o cadastro manual!'
      // this.setCustomers().then((items) => {
      //   this.items = this.getCustomers
      // })
      this.items = []
    },
    computed: {
      ...mapGetters('auth', ['getCustomers']),
      progress () {
        return Math.min(100, this.auth.password.length * 10)
      },
      color () {
        return ['error', 'warning', 'success'][Math.floor(this.progress / 40)]
      }
    },
    data: () => ({
      valid: true,
      showPass: false,
      password: 'Password',
      rules: {
        required: value => !!value || 'Campo obrigatório!',
        min: v => v.length >= 6 || 'Campo tem que ter no mínimo 6 caracteres!'
      },
      snackbarConfig: {
        snackbar: false,
        color: 'error',
        mode: '',
        timeout: 6000,
        text: 'Erro de conexão com o servidor!'
      },
      auth: {
        username: null,
        password: '',
        confpass: null,
        name: null,
        customerId: null,
        crm: null,
        myClinic: []
      },
      crmRules: [
        v => !!v || 'CRM obrigatório',
        v => /^\d+$/.test(v) || 'Somente números!',
        v => (v && v.length <= 8) || 'maximo de 8 caracteres'
      ],
      nameRules: [
        v => !!v || 'Nome é obrigatório',
        v => (v && v.length <= 40) || 'O nome deve conter menos de 40 caracteres'
      ],
      emailRules: [
        v => !!v || 'E-mail é obrigatório',
        v => /.+@.+\..+/.test(v) || 'E-mail não é valido!'
      ],
      items: [],
      checkbox: false,
      lazy: false
    }),
    methods: {
      ...mapActions('auth', ['setCreateUser', 'setCustomers']),
      submit () {
        if (this.$refs.form.validate()) {
          this.getCustomers.map((item) => {
            if (this.auth.customerId._id === item._id) {
              this.auth.myClinic.push({
                crm: this.auth.crm,
                customer: this.auth.customerId,
                client: this.getCustomers.code,
                clientName: this.getCustomers.name,
                state: this.getCustomers.name || 'PR',
                code: this.getCustomers.code,
                name: this.getCustomers.name,
                codeCustomer: this.getCustomers.code,
                customerName: this.getCustomers.name
              })
              this.setCreateUser(this.auth)
                .then()
                .catch((err) => {
                  console.log('err', err.response)
                  this.snackbarConfig.snackbar = true
                  this.snackbarConfig.text = err.response.data.result.error
                })
            }
          })
        }
      },
      reset () {
        this.$refs.form.reset()
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/auth/Sing-up.vue